import {
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import commonStyles from '../../../../styles';

const useStyles = makeStyles({
  root: {
    background: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    fontFamily: 'Roboto',
    fontSize: 13,
    lineHeight: 1.6,
    letterSpacing: 0,
    textAlign: 'left',
    textTransform: 'none',
    borderBottom: '1px solid #F3F3F3',
    borderRadius: 0,
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
  },
  ttl: {
    flexShrink: 0,
    whiteSpace: 'initial',
    '& span': {
      color: '#D83420',
    },
  },
});

function RegisterCustomerCardCalendarSp(props) {
  const { values } = props;
  const classes = useStyles();
  const baseClasses = commonStyles();

  return (
    <Grid className={classes.root}>
      <Typography className={`${baseClasses.title6} ${classes.ttl}`}>
        {values.label}<span>＊</span>
      </Typography>
      <Typography className={baseClasses.title6}>{values.state}</Typography>
    </Grid>
  );
}

export default RegisterCustomerCardCalendarSp;
